import { getAmount } from "../components/guest/hooks";
import { FactureEmise, InvoiceData } from "../redux/types";
// Règle d'exclusion 210/213 : définie une seule fois, avec les libellés.
import { isBcsVoided } from "./bcs-status";
// Même règle que les onglets « Factures dépenses » / « Factures émises
// scannées » : elle ne doit exister qu'à un seul endroit.
import { isEmiseScannee } from "./invoice-type";

// ============================================================================
// Totaux financiers des tableaux de bord — calcul UNIQUE, partagé par l'espace
// admin et l'espace comptable. Il existait auparavant en deux copies qui
// avaient déjà divergé : l'une convertissait les montants, l'autre non.
// ============================================================================

// Les montants arrivent tantôt en nombre, tantôt en chaîne (« 140 », virgule
// décimale). Additionnée telle quelle, une chaîne CONCATÈNE au lieu de sommer :
// observé en production, un total comptable affichait « 8167.461402112.5… ».
// Le repli à 0 écarte aussi un champ absent, qui rendait la somme NaN.
const amount = (v?: string | number) => getAmount(v) || 0;

export type DashboardTotals = {
  total_facture_emise: number;
  total_tva_emise: number;
  total_facture_depense: number;
  total_tva_recuperable: number;
};

export function computeDashboardTotals(
  invoices: InvoiceData[],
  factures: FactureEmise[]
): DashboardTotals {
  const totals: DashboardTotals = {
    total_facture_emise: 0,
    total_tva_emise: 0,
    total_facture_depense: 0,
    total_tva_recuperable: 0,
  };

  // Factures scannées : « Émise » compte en chiffre d'affaires, tout le reste
  // en dépense. Une dépense refusée ne doit surtout pas alimenter la TVA
  // récupérable — ce serait déduire la TVA d'une facture rejetée.
  for (const i of invoices) {
    if (isBcsVoided(i)) continue;
    if (isEmiseScannee(i)) {
      totals.total_facture_emise += amount(i.montant_ht);
      totals.total_tva_emise += amount(i.tva);
    } else {
      totals.total_facture_depense += amount(i.montant_ht);
      totals.total_tva_recuperable += amount(i.tva);
    }
  }

  // Factures émises depuis l'application : un brouillon ou un litige n'est
  // pas un chiffre d'affaires acquis.
  for (const f of factures) {
    if (f.statut === "En cours" || f.statut === "Litige") continue;
    if (isBcsVoided(f)) continue;
    totals.total_facture_emise += amount(f.total_ht_after_remise);
    totals.total_tva_emise += amount(f.total_tva);
  }

  return totals;
}
